/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  activePatientSagaAction,
  unClaimedPatientSagaAction,
  queuedPatientsSagaAction,
  otherPatientSagaAction,
  chatpatient,
  shiftPatientTopSagaAction,
  reorderUnClaimedPatientSagaAction,
  reorderQueuedPatientSagaAction,
  updateOthersPatientListSagaAction,
  PatientCountAction,
  AddPatient,
} from "../../../../sagas/saga-actions";
import { updateMessageStatusSagaAction } from "../../../../sagas/saga-loadChat";
import Fetch from "./fetch";
import SidenavInner from "./sidenavInner";
import loginService from "../../../../service/login";
import UserService from "../../../../service/UserService";
import CustomButton from "../../../../components/customButton";
import CommonService from "../../../../service/CommonService";
import { setPopup } from "../../../../actions/popupAction";
import {
  specialCharRegex,
  searchRegex,
  MOBILE_WIDTH,
} from "../../../../constants/constants";
import {
  CloseIcon,
  SidenavEditIcon,
  ErrorIcon,
  FollowUp,
  InProgress,
} from "../../../../assets/svg";
import "./styles.scss";
import { Tooltip } from "antd";
import TagComp from "./components/tagComponet";
import useWindowDimensions from "../../../../components/custom-hooks/useWindowDimensions";
import { useHistory } from "react-router-dom";
import LiveChatService from "../../../../service/LiveChatService";
import { formatPhoneWithCountryCode } from "../../../../utilities/helpers";

const userService = new UserService();
const commonService = new CommonService();
let lastMarkedSeenPatientId = "";

const Sidenav = (props) => {
  const {
    user,
    activePatient,
    unClaimed,
    patients,
    chatPatient,
    handleChat,
    queuedPatient,
    setChatState = null,
    showPatientReport,
    showPatientLookup,
    chatState,
    Sound,
    handleDownloadReport,
  } = props;

  const liveChatService = new LiveChatService();

  const loadingRef = useRef();
  const archiveRef = useRef();
  const archiveAllRef = useRef();
  const numbersRef = useRef();
  const unclaimedTabRef = useRef();
  const queuedTabRef = useRef();
  const otherTabRef = useRef();
  const wrapperRef = useRef(null);
  const userRef = useRef({});
  const selectedTagRef = useRef("");
  const searchRef = useRef("");

  const { width } = useWindowDimensions();
  const history = useHistory();

  const [state, setState] = useState({
    value: "",
    activeTab: "1",
    page: 1,
    loadingPage: 0,
    unClaimedPage: 1,
    queuedPage: 1,
    otherPage: 2,
    isLoadingActive: false,
    hasMore: true,
    hasMoreUnclaimed: true,
    hasMoreQueued: true,
    hasMoreOthers: true,
    search: "",
    showAddNew: "",
    removeSinglePopup: false,
    removeListPopup: false,
    currentItemId: "",
    otherUserPopup: { show: false, patientData: {} },
    showDropdown: false,
    otherStaffList: [],
    showAddPopUp: false,
    sideNavEdit: false,
    phone: "",
    userDetails: {},
    tags: [],
    labelItems: [],
    selectedTagId: "",
  });
  const [chatDataDetais, setchatDataDetais] = useState("");
  const customUser = props?.user;
  userRef.current = customUser;
  selectedTagRef.current = state.selectedTagId;
  searchRef.current = state.search;

  const followupIcon = <span className="processStatus">{FollowUp}</span>;
  const inprogressIcon = <span className="processStatus">{InProgress}</span>;

  useEffect(
    () => {
      function handleClickOutside(event) {
        if (!wrapperRef?.current?.contains(event.target)) {
          setState((st) => ({
            ...st,
            showDropdown: false,
          }));
        }
      }

      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    },
    [wrapperRef]
  );

  useEffect(() => {
    getTags();
  }, []);

  const getTags = async () => {
    try {
      const tags = await userService.getTagConversation();
      let items = tags.map((e) => ({
        key: e.id,
        label: e.tagName,
      }));
      items = [
        {
          key: "0",
          label: "None",
        },
        ...items,
      ];
      if (items.length >= 3) {
        items[1].icon = inprogressIcon;
        items[2].icon = followupIcon;
      }
      setState((st) => ({
        ...st,
        tags: tags,
        labelItems: items,
      }));
    } catch (e) {
      props.setPopup({
        customPopupMessage: true,
        messageType: "error",
        message: "Something went wrong.",
      });
    }
  };

  // load active patients on load when user has logged in.
  const loadMoreActiveUsers = () => {
    const { page, loadingPage = 0 } = state;
    if (page >= 0 && loadingPage !== page) {
      const offset = page + 1;
      setState((st) => ({ ...st, isLoadingActive: true, loadingPage: page }));
      const activeArrayList = activePatient?.activePatientList
        ? activePatient.activePatientList
        : [];

      Fetch.getUsers(
        user.id,
        "active",
        offset,
        state.search,
        state.selectedTagId
      )
        .then((response) => {
          if (response?.length > 0) {
            let newUsers = [...activeArrayList, ...response];
            newUsers = [...new Set(newUsers)];
            props.shiftPatientTopSagaAction(newUsers);

            setState((st) => ({
              ...st,
              page: page + 1,
              isLoadingActive: false,
            }));
          } else {
            setState((st) => ({
              ...st,
              isLoadingActive: false,
              hasMore: false,
            }));
          }
        })
        .catch(() => {
          setState((st) => ({ ...st, isLoadingActive: false, hasMore: false }));
        });
    }
  };

  const loadMoreUnClaimedUsers = () => {
    let { unClaimedPage, loadingPage } = state;
    if (unClaimedPage >= 0 && unClaimedPage !== loadingPage) {
      const offset = unClaimedPage + 1;

      setState((st) => ({
        ...st,
        isLoadingActive: true,
        loadingPage: unClaimedPage,
      }));
      const unClaimedArrayList = unClaimed?.unclaimedPatientList
        ? unClaimed.unclaimedPatientList
        : [];

      Fetch.getUsers(user.id, "unclaimed", offset, state.search)
        .then((response) => {
          if (response?.length > 0) {
            let newUsers = [...unClaimedArrayList, ...response];
            newUsers = new Set(newUsers);
            props.reorderUnClaimedPatientSagaAction([...newUsers]);

            setState((st) => ({
              ...st,
              unClaimedPage: unClaimedPage + 1,
              isLoadingActive: false,
            }));
          } else {
            setState((st) => ({
              ...st,
              isLoadingActive: false,
              hasMoreUnclaimed: false,
            }));
          }
        })
        .catch(() => {
          setState((st) => ({
            ...st,
            isLoadingActive: false,
            hasMoreUnclaimed: false,
          }));
        });
    }
  };

  const loadMoreQueuedUsers = async () => {
    let { queuedPage, loadingPage } = state;
    if (queuedPage >= 0 && queuedPage !== loadingPage) {
      const offset = queuedPage + 1;

      setState((st) => ({
        ...st,
        isLoadingActive: true,
        loadingPage: queuedPage,
      }));
      const queuedArrayList = queuedPatient?.queuedPatientList
        ? queuedPatient.queuedPatientList
        : [];

      Fetch.getUsers(user.id, "queued", offset, state.search)
        .then((response) => {
          if (response?.length > 0) {
            let newUsers = [...queuedArrayList, ...response];
            newUsers = new Set(newUsers);
            props.reorderQueuedPatientSagaAction([...newUsers]);

            setState((st) => ({
              ...st,
              queuedPage: queuedPage + 1,
              isLoadingActive: false,
            }));
          } else {
            setState((st) => ({
              ...st,
              isLoadingActive: false,
              hasMoreQueued: false,
            }));
          }
        })
        .catch(() => {
          setState((st) => ({
            ...st,
            isLoadingActive: false,
            hasMoreQueued: false,
          }));
        });
    }
  };

  const loadMoreOtherUsersNew = async () => {
    if (state.otherPage < props.count.other && !loadingRef.current) {
      loadingRef.current = true;
      const pageSize = state.otherPage + 1;

      await Fetch.getUsers(user.id, "others", state.otherPage, state.search)
        .then((response) => {
          if (response?.rows.length > 0) {
            const newData = [...state.otherStaffList, ...response.rows];
            setState((st) => ({
              ...st,
              otherPage: pageSize,
              otherStaffList: newData,
            }));
            props.updateOthersPatientListSagaAction({
              ...props.otherPatients.otherPatientList,
              rows: [
                ...props.otherPatients.otherPatientList.rows,
                ...response.rows,
              ],
            });
          } else {
            setState((st) => ({ ...st, hasMoreOthers: false }));
          }
          loadingRef.current = false;
        })
        .catch((err) => {
          loadingRef.current = false;
        });
    }
  };

  const updateMessageCount = (message) => {
    const activeArrayList = Array.isArray(activePatient?.activePatientList)
      ? activePatient.activePatientList
      : [];
    const patientClaimedForUser = activeArrayList.find(
      (patient) => patient?.id === message?.msg?.patientId
    );
    const notificationSoundForUnclaimed = JSON.parse(
      localStorage.getItem("notificationSoundForUnclaimed")
    );
    const user = userRef?.current;
    if (user?.id) {
      const obj = { offset: 0, userId: user.id, tag: state.selectedTagId };
      if (!message.textChat || !message.msg || !message.msg.sendLinkMessage) {
        setState((st) => ({
          ...st,
          page: 1,
          hasMore: true,
          loadingPage: 0,
        }));

        if (numbersRef?.current) {
          numbersRef.current.scrollTo(0, 0);
        }

        if (unclaimedTabRef?.current) {
          unclaimedTabRef.current.scrollTo(0, 0);
        }

        if (queuedTabRef?.current) {
          queuedTabRef.current.scrollTo(0, 0);
        }
        if (
          loginService.isLoggedin() &&
          message?.msg?.conversationType === "inbound" &&
          !message?.msg?.vacConversationId &&
          !chatState?.showChat &&
          history.location.pathname === "/chat"
        ) {
          if (
            (notificationSoundForUnclaimed && !patientClaimedForUser) ||
            patientClaimedForUser
          ) {
            Sound?.receive();
          }
        }
        if (user.practiceId === message?.msg?.practiceId) {
          props.activePatientSagaAction(obj);
          props.unClaimedPatientSagaAction(obj);
        }
      }
    }
    if (message?.msg) {
      updateMessageCountWorker(message.msg.patientId);
    }
  };

  const isEmpty = (obj) => {
    for (let prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
    return true;
  };

  const updateMessageCountWorker = (patientId, setToZero) => {
    const { patient } = patients;

    if (state.activeTab === "1") {
      let activeArrayList = [];
      if (activePatient?.activePatientList?.length) {
        activeArrayList = activePatient.activePatientList;
      } else {
        activeArrayList = activePatient?.activePatientList
          ? [activePatient.activePatientList]
          : [];
      }

      const existedPatientIndex = activeArrayList.findIndex(
        (u) => u.id === patientId
      );

      if (
        activeArrayList[existedPatientIndex] &&
        isEmpty(patient) === false &&
        patient.id === activeArrayList[existedPatientIndex].id
      ) {
        if (existedPatientIndex > -1) {
          if (setToZero) {
            activeArrayList[existedPatientIndex].count = 0;
            props.shiftPatientTopSagaAction([...activeArrayList]);
          }
        }
      } else {
        if (existedPatientIndex > -1) {
          if (setToZero) {
            activeArrayList[existedPatientIndex].count = 0;
          } else {
            activeArrayList[existedPatientIndex].count =
              (activeArrayList[existedPatientIndex].count || 0) + 1;
          }
          props.shiftPatientTopSagaAction([...activeArrayList]);
        }
      }
    }

    if (state.activeTab === "2") {
      const unClaimedList = unClaimed?.unclaimedPatientList
        ? unClaimed.unclaimedPatientList
        : [];
      const existedUnClaimedPatientIndex = unClaimedList.findIndex(
        (patient) => patient.id === patientId
      );
      if (
        unClaimedList[existedUnClaimedPatientIndex] &&
        isEmpty(patient) === false &&
        patient.id === unClaimedList[existedUnClaimedPatientIndex].id
      ) {
        //nothing to do , please don't remove this comment
      } else if (existedUnClaimedPatientIndex > -1) {
        if (setToZero) {
          unClaimedList[existedUnClaimedPatientIndex].count = 0;
        } else {
          unClaimedList[existedUnClaimedPatientIndex].count =
            (unClaimedList[existedUnClaimedPatientIndex].count || 0) + 1;
        }
        props.reorderUnClaimedPatientSagaAction([...unClaimedList]);
      }
    }

    if (state.activeTab === "") {
      const queuedPatients = queuedPatient?.queuedArrayList
        ? queuedPatient.queuedArrayList
        : [];
      const existedQueuedPatientIndex = queuedPatients.findIndex(
        (patient) => patient.id === patientId
      );
      if (
        queuedPatients[existedQueuedPatientIndex] &&
        isEmpty(patient) === false &&
        patient.id === queuedPatients[existedQueuedPatientIndex].id
      ) {
        //nothing to do , please don't remove this comment
      } else if (existedQueuedPatientIndex > -1) {
        if (setToZero) {
          queuedPatients[existedQueuedPatientIndex].count = 0;
        } else {
          queuedPatients[existedQueuedPatientIndex].count =
            (queuedPatients[existedQueuedPatientIndex].count || 0) + 1;
        }
      }
    }
  };

  useEffect(() => {
    const selectedPatient = patients?.patient;
    const selectedPatientId = selectedPatient?.id || "";

    // Deselected (tab switch, claim/revoke/transfer set patients.patient = {}):
    // clear the guard so a later re-open of any patient can mark-seen again.
    if (!selectedPatientId) {
      lastMarkedSeenPatientId = "";
      return;
    }

    // Already marked this opened conversation — nothing to do.
    if (lastMarkedSeenPatientId === selectedPatientId) {
      return;
    }

    const unreadCount = selectedPatient?.count || 0;
    if (!unreadCount) {
      // Opened a conversation with no unread — nothing to mark seen.
      return;
    }

    // Claim this selection before issuing the request so any re-render in the
    // same tick (or before it resolves) cannot send a second identical request.
    lastMarkedSeenPatientId = selectedPatientId;
    console.info(
      `[Conversation] markSeen → patientId=${selectedPatientId} unread=${unreadCount}`
    );

    Promise.resolve(liveChatService.updateSelectedChatCount(selectedPatientId))
      .then(() =>
        console.info(`[Conversation] markSeen ✓ patientId=${selectedPatientId}`)
      )
      .catch((e) =>
        console.error(
          `[Conversation] markSeen ✗ patientId=${selectedPatientId}`,
          e
        )
      );

    // Reset the local unread badge for the selected patient.
    updateMessageCountWorker(selectedPatientId, true);
  }, [patients?.patient?.id]);

  const displayChatBoxEmpty = () => {
    handleChat(false);

    if (user?.id) {
      const obj = {
        offset: 0,
        userId: user.id,
      };

      props.activePatientSagaAction(obj);
    }
  };

  const tabing = (tab, resetSearch = false, search = "") => {
    setState((st) => ({
      ...st,
      page: 1,
      unClaimedPage: 1,
      loadingPage: 0,
      hasMore: true,
      hasMoreUnclaimed: true,
      hasMoreQueued: true,
      hasMoreOthers: true,
      activeTab: tab,
    }));

    resetSearch &&
      setState((st) => ({
        ...st,
        search: "",
        showAddNew: false,
      }));

    handleChat(false);

    chatPatient({});

    const obj = {
      userId: userRef?.current?.id,
      offset: 0,
      search: resetSearch ? "" : search,
      tag: "",
    };

    if (tab === "1") {
      localStorage.setItem("tabSet", "activeItem");

      if (userRef?.current?.id) {
        props.activePatientSagaAction(obj);
      }
    } else if (tab === "2") {
      localStorage.setItem("tabSet", "unClaimedItem");

      if (userRef?.current?.id) {
        props.unClaimedPatientSagaAction(obj);
        setState((st) => ({
          ...st,
          selectedTagId: "",
        }));
      }
    } else if (tab === "4") {
      localStorage.setItem("tabSet", "otherItem");

      if (userRef?.current?.id) {
        props.otherPatientSagaAction(obj);
        setState((st) => ({
          ...st,
          otherPage: 2,
          otherStaffList: props.otherPatients.otherPatientList?.rows,
          selectedTagId: "",
        }));
      }
    }

    if (numbersRef?.current?.scrollTo) {
      numbersRef.current.scrollTo(0, 0);
    }

    if (unclaimedTabRef?.current?.scrollTo) {
      unclaimedTabRef.current.scrollTo(0, 0);
    }

    if (queuedTabRef?.current?.scrollTo) {
      queuedTabRef.current.scrollTo(0, 0);
    }

    if (otherTabRef?.current?.scrollTo) {
      otherTabRef.current.scrollTo(0, 0);
    }
  };

  // set active user to active user listing
  const activateChatUser = (patientData) => {
    setChatState((st) => ({
      ...st,
      chatSelected: patientData,
    }));
    chatPatient(patientData);

    if (user?.id) {
      updateMessageCountWorker(patientData.id, true);

      handleChat(true);

      props.getActivePatientNumber(patientData.cellPhone);
    }
    setState((st) => ({
      ...st,
      search: "",
    }));
  };

  // set unclaimed user to active user listing
  const claimToUser = (patientData) => {
    chatPatient(patientData);
    setChatState((st) => ({
      ...st,
      chatSelected: patientData,
    }));
    if (user?.id) {
      updateMessageCountWorker(patientData.id, true);

      handleChat(true);
    }
  };

  // set queued patients to claim
  const queuedUsersClaim = (patientData) => {
    chatPatient(patientData);

    if (user?.id) {
      updateMessageCountWorker(patientData.id, true);

      handleChat(true);
    }
  };

  // set other user to active user listing
  const otherUserClaim = (patientData) => {
    chatPatient(patientData);
    setChatState((st) => ({
      ...st,
      chatSelected: patientData,
    }));
    if (user?.id) {
      updateMessageCountWorker(patientData.id, true);

      handleChat(true);
    }
  };

  // set active tab when claimed or revoked
  const setActiveTab = (obj) => {
    if (!loginService.isLoggedin()) {
      return;
    }

    setState((st) => ({ ...st, search: "", showAddNew: false }));

    if (obj?.tab === 2) {
      if (unClaimed.unclaimedPatientList) {
        const patient = unClaimed.unclaimedPatientList.find(
          (x) => x.id === obj.id
        );

        patient && claimToUser(patient);
      }
    }
    if (obj?.tab === 1) {
      if (activePatient.activePatientList) {
        const patient = activePatient.activePatientList.find(
          (patient) => patient.id === obj.id
        );
        patient && activateChatUser(patient);
      }
    }
  };

  const activateNew = (patientData) => {
    setState((st) => ({ ...st, search: "", showAddNew: false }));

    props.PatientCount();
    props.shiftPatientTopSagaAction(patientData);

    tabing("1");

    activateChatUser(patientData);

    const obj = {
      offset: 0,
      userId: patientData.claimedUserId,
      tag: "",
    };

    props.activePatientSagaAction(obj);
  };

  const fetchPatientData = async (searchString, forEdit) => {
    try {
      const data = await Fetch.getUserDetails(searchString, forEdit);
      return JSON.parse(JSON.stringify(data)) || {};
    } catch (err) {
      props.setPopup({
        customPopupMessage: true,
        messageType: "error",
        message: err || "Something wen't wrong",
      });

      return {};
    }
  };

  // add new number to patient
  const handleNewNumber = async () => {
    const patientData = await fetchPatientData(state.search, false);

    if (patientData?.success === false) {
      props.setPopup({
        customPopupMessage: true,
        messageType: "info",
        message: patientData?.message || "Patient Already Added.",
      });
    } else {
      setState((st) => ({
        ...st,
        userDetails: patientData,
        showAddPopUp: true,
        phone: state.search,
        sideNavEdit: false,
      }));
    }
  };

  const handleEditPatientAccess = async (phone) => {
    const patientData = await fetchPatientData(phone, true);

    if (patientData?.success !== false) {
      setState((st) => ({
        ...st,
        userDetails: patientData,
        showAddPopUp: true,
        sideNavEdit: true,
        phone: phone,
      }));
    }
  };

  const addNewButton = () => {
    if (
      searchRegex.test(state.desiredSearch) &&
      !specialCharRegex.test(state.search)
    ) {
      return (
        <CustomButton
          htmlType="submit"
          type="primary"
          title="Add Number"
          onClick={handleNewNumber}
        />
      );
    }
  };

  const handleUnread = () => {
    if (user?.id) {
      tabing("1", true);
      setState((st) => ({
        ...st,
        selectedTagId: "",
        search: "",
      }));
      setChatState((st) => ({ ...st, selectedTagId: "" }));
    }
  };

  const LabelButton = ({ key }) => {
    tabing("1", true);
    const obj = {
      offset: 0,
      userId: user.id,
      tag: key,
    };
    props.activePatientSagaAction(obj);
    setChatState((st) => ({ ...st, selectedTagId: key }));
    setState((st) => ({
      ...st,
      selectedTagId: key,
      search: "",
    }));
  };

  // render active tab patient list
  const listingActivePatients = () => {
    const seletedPatientId = patients?.patient?.id || "";
    if (activePatient?.activePatientList?.length > 0) {
      const sortedPatientList = activePatient.activePatientList.sort(
        (a, b) =>
          new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
      );

      const colorMap = {
        "Follow Up": "followup",
        "In Progress": "inprogress",
      };

      return (
        <>
          {sortedPatientList.map((value, index) => {
            const {
              id,
              firstName,
              lastName,
              cellPhone,
              countryCode,
              count,
              medicalRecordNumber,
              conversation_tag,
            } = value;
            if (cellPhone) {
              return (
                <li
                  className={`phone-number-item ${
                    seletedPatientId === id ? "active-phone-number" : ""
                  }`}
                  key={index}
                  onClick={() => activateChatUser(value)}
                >
                  {firstName || lastName ? (
                    <article className="user-details-wrapper">
                      <p className="user-name">
                        <a
                          title={`${firstName} ${lastName || ""}`}
                        >{`${firstName} ${lastName || ""}`}</a>
                      </p>

                      <p className="user-number">
                        {formatPhoneWithCountryCode(cellPhone, countryCode)}
                      </p>
                      {conversation_tag && (
                        <p className={colorMap[conversation_tag.tagName]}>
                          {conversation_tag.tagName === "Follow Up" &&
                            followupIcon}
                          {conversation_tag.tagName === "In Progress" &&
                            inprogressIcon}
                          {conversation_tag.tagName}
                        </p>
                      )}
                    </article>
                  ) : (
                    <article className="user-details-wrapper">
                      <p className="user-name">
                        {formatPhoneWithCountryCode(cellPhone, countryCode)}
                      </p>
                      {conversation_tag && (
                        <span className={colorMap[conversation_tag.tagName]}>
                          {conversation_tag.tagName === "Follow Up" &&
                            followupIcon}
                          {conversation_tag.tagName === "In Progress" &&
                            inprogressIcon}
                          {conversation_tag.tagName}
                        </span>
                      )}
                    </article>
                  )}

                  <div className="number-details">
                    <div className="msg-count">
                      {count !== 0 && seletedPatientId !== id ? count : ""}
                    </div>
                    {props.user.editPatientAccess === 1 && (
                      <Tooltip title="Edit Patient">
                        <div
                          className="delete-icon"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditPatientAccess(cellPhone);
                          }}
                        >
                          <SidenavEditIcon />
                        </div>
                      </Tooltip>
                    )}
                    <span className="delete-icon">
                      <TagComp
                        tags={state.tags}
                        patient={id}
                        user={props.user}
                        conversation_tag={conversation_tag}
                        filteredTag={state.selectedTagId}
                      />
                    </span>
                    <div
                      className="delete-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        setState((st) => ({
                          ...st,
                          removeSinglePopup: true,
                          currentItemId: id,
                        }));
                      }}
                    >
                      <CloseIcon />
                    </div>
                  </div>
                </li>
              );
            }
            return null;
          })}
        </>
      );
    } else {
      return (
        <div className="side-tabs-empty">
          <ErrorIcon />
          <p className="error-message">No record found for active patients.</p>
          {state.showAddNew ? addNewButton() : ""}
        </div>
      );
    }
  };

  const listingUnclaimedPatients = () => {
    const seletedPatientId = patients?.patient?.id || "";
    if (unClaimed?.unclaimedPatientList?.length > 0) {
      return (
        <>
          {unClaimed.unclaimedPatientList.map((value, index) => {
            return (
              <li
                className={`phone-number-item ${
                  seletedPatientId === value.id ? "active-phone-number" : ""
                }`}
                key={index}
                onClick={() => claimToUser(value)}
              >
                {value.firstName || value?.lastName ? (
                  <article className="user-details-wrapper">
                    <p className="user-name">
                      <a title={`${value.firstName} ${value?.lastName || ""}`}>
                        {`${value.firstName} ${value?.lastName || ""}`}
                      </a>
                    </p>

                    <p className="user-number">
                      {formatPhoneWithCountryCode(
                        value.cellPhone,
                        value.countryCode
                      )}
                    </p>
                  </article>
                ) : (
                  <article className="user-details-wrapper">
                    <p className="user-name">
                      {formatPhoneWithCountryCode(
                        value.cellPhone,
                        value.countryCode
                      )}
                    </p>
                  </article>
                )}
                <div className="number-details">
                  <div className="msg-count">
                    {value.count !== 0 ? value.count : ""}
                  </div>

                  <div
                    className="delete-icon"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setState((st) => ({
                        ...st,
                        removeSinglePopup: true,
                        currentItemId: value.id,
                      }));
                    }}
                  >
                    <CloseIcon />
                  </div>
                </div>
              </li>
            );
          })}
        </>
      );
    } else {
      return (
        <div className="side-tabs-empty">
          <ErrorIcon />
          <p className="error-message">
            No record found for unclaimed patients.
          </p>
          {state.showAddNew ? addNewButton() : ""}
        </div>
      );
    }
  };

  const listingQueuedPatients = () => {
    const seletedPatientId = patients?.patient?.id || "";
    if (queuedPatient?.queuedPatientList?.length > 0) {
      return (
        <>
          {queuedPatient.queuedPatientList.map((value, index) => {
            return (
              <li
                className={`phone-number-item ${
                  seletedPatientId === value.id ? "active-phone-number" : ""
                }`}
                key={index}
                onClick={() => queuedUsersClaim(value)}
              >
                {value.firstName || value?.lastName ? (
                  <article className="user-details-wrapper">
                    <p className="user-name">
                      <a title={`${value.firstName} ${value?.lastName || ""}`}>
                        {`${value.firstName} ${value?.lastName || ""}`}
                      </a>
                    </p>
                    <p className="user-number">
                      {formatPhoneWithCountryCode(
                        value.cellPhone,
                        value.countryCode
                      )}
                    </p>
                  </article>
                ) : (
                  <article className="user-details-wrapper">
                    <p className="user-name">
                      {formatPhoneWithCountryCode(
                        value.cellPhone,
                        value.countryCode
                      )}
                    </p>
                  </article>
                )}
                <div className="number-details">
                  <div className="msg-count">
                    {value.count !== 0 ? value.count : ""}
                  </div>
                </div>
              </li>
            );
          })}
        </>
      );
    } else {
      return (
        <div className="side-tabs-empty">
          <ErrorIcon />
          <p className="error-message">
            No record found for unclaimed patients.
          </p>
          {state.showAddNew ? addNewButton() : ""}
        </div>
      );
    }
  };

  const handleSearch = (e) => {
    let search = e.target.value;
    const desiredSearch = search?.replace(/[^0-9a-z\(\)-\s]/gi, "");
    const showAddNew = searchRegex.test(search);
    setState((st) => ({ ...st, search, desiredSearch, showAddNew }));

    let currentTab = state.activeTab;
    let searchMethod = tabing;

    // set timeout so that the search waits while the user is typing
    setTimeout(() => {
      searchMethod(currentTab, false, search);
    }, 1000);
  };

  const handleOnClear = async () => {
    if (!archiveAllRef.current) {
      archiveAllRef.current = true;
      if (state.activeTab === "1") {
        try {
          await commonService.clearChat({
            archiveAll: {
              state: true,
              tab: "active",
            },
          });

          props.setPopup({
            customPopupMessage: true,
            messageType: "success",
            message: "Active patients list has been cleared successfully.",
          });
          setState((st) => ({ ...st, removeListPopup: false }));

          if (user?.id) {
            const obj = {
              offset: 0,
              userId: user.id,
              tag: "",
            };
            props.activePatientSagaAction(obj);
            setState((st) => ({ ...st, selectedTagId: "" }));
          }
          props.PatientCount();
        } catch (e) {
          props.setPopup({
            customPopupMessage: true,
            messageType: "error",
            message: "Something went wrong.",
          });
          setState((st) => ({ ...st, removeListPopup: false }));
        }
      } else {
        try {
          await commonService.clearChat({
            archiveAll: {
              state: true,
              tab: "unclaimed",
            },
          });

          props.setPopup({
            customPopupMessage: true,
            messageType: "success",
            message: "Unclaimed patients list has been cleared successfully.",
          });
          setState((st) => ({ ...st, removeListPopup: false }));
          if (user?.id) {
            const obj = {
              offset: 0,
              userId: user.id,
            };
            props.unClaimedPatientSagaAction(obj);
          }
          props.PatientCount();
        } catch (e) {
          props.setPopup({
            customPopupMessage: true,
            messageType: "error",
            message: "Something went wrong.",
          });
          setState((st) => ({ ...st, removeListPopup: false }));
        }
      }

      archiveAllRef.current = false;
    }
  };

  const handleSinglePatientClear = async (id) => {
    if (!archiveRef.current) {
      try {
        archiveRef.current = true;

        await commonService.clearChat({
          patientIds: [id],
          tab: state.activeTab,
        });

        props.setPopup({
          customPopupMessage: true,
          messageType: "success",
          message: "Patient has been cleared successfully.",
        });
        setState((st) => ({ ...st, removeSinglePopup: false }));
        if (state.activeTab === "1") {
          localStorage.setItem("tabSet", "activeItem");

          if (user?.id) {
            const obj = {
              offset: 0,
              userId: user.id,
              tag: state.selectedTagId,
            };
            props.activePatientSagaAction(obj);
          }
          props.PatientCount();
        } else {
          localStorage.setItem("tabSet", "unClaimedItem");

          if (user?.id) {
            const obj = {
              offset: 0,
              userId: user.id,
            };

            props.unClaimedPatientSagaAction(obj);
          }

          props.PatientCount();

          setState((st) => ({ ...st, activeTab: "2" }));
        }
      } catch (e) {
        props.setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: "Something went wrong.",
        });

        setState((st) => ({ ...st, removeSinglePopup: false }));
      }

      archiveRef.current = false;
    }
  };

  const checkClear = (activeTab) => {
    if (activeTab === "3" && activeTab === "4") {
      return false;
    } else if (
      props.activePatient.activePatientList.length > 0 &&
      activeTab === "1"
    ) {
      return true;
    } else if (
      props.unClaimed?.unclaimedPatientList?.length > 0 &&
      activeTab === "2"
    ) {
      return true;
    } else {
      return false;
    }
  };

  const showTabsDropdown = () => {
    setState((st) => ({ ...st, showDropdown: !st.showDropdown }));
  };

  const syncCurrentTabData = (resetSearch = false) => {
    const currentUserId = userRef?.current?.id;
    if (!currentUserId) {
      return;
    }

    const tabSet = localStorage.getItem("tabSet");
    const search = resetSearch ? "" : searchRef.current;
    const obj = {
      userId: currentUserId,
      offset: 0,
      search,
      tag: tabSet === "activeItem" ? selectedTagRef.current : "",
    };

    if (resetSearch) {
      setState((st) => ({
        ...st,
        search: "",
        showAddNew: false,
      }));
    }

    if (tabSet === "unClaimedItem") {
      props.unClaimedPatientSagaAction(obj);
      return;
    }

    if (tabSet === "queuedItem") {
      props.queuedPatientsSagaAction(obj);
      return;
    }

    if (tabSet === "otherItem") {
      props.otherPatientSagaAction(obj);
      return;
    }

    props.activePatientSagaAction(obj);
  };

  useEffect(() => {
    localStorage.setItem("tabSet", "activeItem");

    const getCurrentTab = () => {
      const currentTab = localStorage.getItem("tabSet");

      if (currentTab === "unClaimedItem") {
        return "2";
      }
      if (currentTab === "queuedItem") {
        return "3";
      }
      if (currentTab === "otherItem") {
        return "4";
      }
      return "1";
    };

    const initialRender = () => {
      if (numbersRef?.current?.scrollTo) {
        numbersRef.current.scrollTo(0, 0);
      }

      if (unclaimedTabRef?.current?.scrollTo) {
        unclaimedTabRef.current.scrollTo(0, 0);
      }

      if (queuedTabRef?.current?.scrollTo) {
        queuedTabRef.current.scrollTo(0, 0);
      }

      if (otherTabRef?.current?.scrollTo) {
        otherTabRef.current.scrollTo(0, 0);
      }

      const user = loginService.getUser();
      if (user?.id) {
        const obj = {
          offset: 0,
          userId: user.id,
          tag: selectedTagRef.current,
        };
        props.activePatientSagaAction(obj);
      }
      props.PatientCount();
    };

    initialRender();

    const handleUpdateTab = () => {
      tabing("1");
    };

    const handleCloseChatInput = () => {
      displayChatBoxEmpty();
    };

    const handleRevokeUser = () => {
      tabing(getCurrentTab());
    };

    const handleSetActivePatient = (e) => {
      setActiveTab(e.detail);
      tabing(getCurrentTab());
    };

    const handleReceiveTextMessageFromSocket = (e) => {
      props.PatientCount();
      setchatDataDetais(e.detail);
    };

    const handleSyncPatientCount = () => {
      // Keep current chat open while refreshing list/count updates from socket.
      syncCurrentTabData(true);
      props.PatientCount();
    };

    const handleRefreshCurrentTab = () => {
      tabing(getCurrentTab());
    };

    window.addEventListener("updateTab", handleUpdateTab, false);
    window.addEventListener("closeChatInput", handleCloseChatInput, false);
    window.addEventListener("revokeUser", handleRevokeUser, false);
    window.addEventListener("setActivePatient", handleSetActivePatient, false);
    window.addEventListener(
      "receiveTextMessageFromSocket",
      handleReceiveTextMessageFromSocket,
      false
    );
    window.addEventListener("syncPatientCount", handleSyncPatientCount, false);
    window.addEventListener("refreshCurrentTab", handleRefreshCurrentTab, false);

    return () => {
      window.removeEventListener("updateTab", handleUpdateTab);
      window.removeEventListener("closeChatInput", handleCloseChatInput);
      window.removeEventListener("revokeUser", handleRevokeUser);
      window.removeEventListener("setActivePatient", handleSetActivePatient);
      window.removeEventListener(
        "receiveTextMessageFromSocket",
        handleReceiveTextMessageFromSocket
      );
      window.removeEventListener("syncPatientCount", handleSyncPatientCount);
      window.removeEventListener("refreshCurrentTab", handleRefreshCurrentTab);
    };
  }, []);

  useEffect(
    () => {
      if (chatDataDetais) {
        updateMessageCount(chatDataDetais);
      }
    },
    [chatDataDetais]
  );

  const handleCancel = () => {
    setState((st) => ({ ...st, removeSinglePopup: false }));
  };

  const handleConfirmPopupCancel = () => {
    setState((st) => ({
      ...st,
      otherUserPopup: { show: false, patientData: {} },
    }));
  };

  const handleConfirmPopupDelete = () => {
    activateNew(data);
    setState((st) => ({
      ...st,
      otherUserPopup: { show: false, patientData: {} },
    }));
  };

  const handleConfirmPopupClear = () => {
    setState((st) => ({ ...st, removeListPopup: false }));
  };

  const handleDropdown = () => {
    setState((st) => ({
      ...st,
      showDropdown: !st.showDropdown,
    }));
  };

  const handleSearchClear = () => {
    setState((st) => ({ ...st, removeListPopup: true }));
  };

  const hideAddPopUp = () => {
    setState((st) => ({ ...st, showAddPopUp: false }));
  };
  const sideNavEdit = () => {
    setState((st) => ({ ...st, showAddPopUp: false }));
  };

  const setNewPhoneValue = async (values) => {
    const userId = user?.id;
    const filteredSearch = !state.sideNavEdit
      ? state.search.replace(/[^0-9a-z]/gi, "")
      : values.phone.toString().replace(/[^0-9a-z]/gi, "");
    let patientData = {},
      ehrName = user?.practice?.ehrName
        ? user.practice.ehrName?.toLowerCase()
        : "";
    patientData["claimedUserId"] = user?.id || "";
    patientData["ehr"] = ehrName;
    patientData["cellPhone"] = filteredSearch;
    patientData["active"] = true;
    patientData["practiceId"] = user?.practiceId || "";
    patientData["userName"] = user?.username || "";
    patientData["firstName"] = values?.firstName || "";
    patientData["dateOfBirth"] = values?.dob || "";
    patientData["medicalRecordNumber"] = values?.mrn || "";
    patientData["lastName"] = values?.lastName || "";
    patientData["countryCode"] = values?.countryCode || "";

    const otherStaffNumbers = await userService.getOtherPatientList(userId);

    if (
      otherStaffNumbers?.length &&
      otherStaffNumbers
        .map((number) =>
          number.patients.map((patient) => `${patient.cellPhone}`)
        )
        .join(",")
        .split(",")
        .includes(state.search)
    ) {
      setState((st) => ({
        ...st,
        otherUserPopup: { show: true, patientData },
      }));
    } else {
      try {
        await props.AddPatient(patientData, (data, response) => {
          if (data) {
            activateNew(data);
            hideAddPopUp();
            props.setPopup({
              customPopupMessage: true,
              messageType: "success",
              message: response.message,
            });
          } else {
            hideAddPopUp();
            props.setPopup({
              customPopupMessage: true,
              messageType: "error",
              message: response,
            });
          }
        });

        props.PatientCount();
      } catch (e) {
        props.setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: "Something went wrong",
        });
      }
    }
    if (width < MOBILE_WIDTH) {
      history.push("/");
    }
  };

  return (
    <SidenavInner
      sidenavProps={props}
      sidenavState={state}
      handleSinglePatientClear={handleSinglePatientClear}
      handleOnClear={handleOnClear}
      tabing={tabing}
      showTabsDropdown={showTabsDropdown}
      handleSearch={handleSearch}
      checkClear={checkClear}
      loadMoreActiveUsers={loadMoreActiveUsers}
      listingActivePatients={listingActivePatients}
      loadMoreUnClaimedUsers={loadMoreUnClaimedUsers}
      otherTabRef={otherTabRef}
      otherUserClaim={otherUserClaim}
      addNewButton={addNewButton}
      listingUnclaimedPatients={listingUnclaimedPatients}
      listingQueuedPatients={listingQueuedPatients}
      loadMoreOtherUsersNew={loadMoreOtherUsersNew}
      loadMoreQueuedUsers={loadMoreQueuedUsers}
      unclaimedTabRef={unclaimedTabRef}
      queuedTabRef={queuedTabRef}
      numbersRef={numbersRef}
      wrapperRef={wrapperRef}
      handleCancel={handleCancel}
      handleConfirmPopupCancel={handleConfirmPopupCancel}
      handleConfirmPopupDelete={handleConfirmPopupDelete}
      handleConfirmPopupClear={handleConfirmPopupClear}
      handleDropdown={handleDropdown}
      handleSearchClear={handleSearchClear}
      hideAddPopUp={hideAddPopUp}
      setNewPhoneValue={setNewPhoneValue}
      getTags={getTags}
      LabelButton={LabelButton}
      handleUnread={handleUnread}
      showPatientReport={showPatientReport}
      showPatientLookup={showPatientLookup}
      notConfigured={chatState.notConfigured}
      handleDownloadReport={handleDownloadReport}
    />
  );
};

const mapStateToProps = (state) => ({
  patients: state.patients,
  user: state.login.user,
  activePatient: state.activePatient,
  otherPatients: state.otherPatients,
  unClaimed: state.unClaimed,
  queuedPatient: state.queuedPatient,
  loadChat: state.loadChat,
  count: state.patientCount,
  popupReducer: state.popupReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    activePatientSagaAction: bindActionCreators(
      activePatientSagaAction,
      dispatch
    ),
    unClaimedPatientSagaAction: bindActionCreators(
      unClaimedPatientSagaAction,
      dispatch
    ),
    queuedPatientsSagaAction: bindActionCreators(
      queuedPatientsSagaAction,
      dispatch
    ),
    reorderQueuedPatientSagaAction: bindActionCreators(
      reorderQueuedPatientSagaAction,
      dispatch
    ),
    otherPatientSagaAction: bindActionCreators(
      otherPatientSagaAction,
      dispatch
    ),
    chatPatient: bindActionCreators(chatpatient, dispatch),
    shiftPatientTopSagaAction: bindActionCreators(
      shiftPatientTopSagaAction,
      dispatch
    ),
    reorderUnClaimedPatientSagaAction: bindActionCreators(
      reorderUnClaimedPatientSagaAction,
      dispatch
    ),
    updateMessageStatusSagaAction: bindActionCreators(
      updateMessageStatusSagaAction,
      dispatch
    ),
    updateOthersPatientListSagaAction: bindActionCreators(
      updateOthersPatientListSagaAction,
      dispatch
    ),
    PatientCount: bindActionCreators(PatientCountAction, dispatch),
    AddPatient: bindActionCreators(AddPatient, dispatch),
    setPopup: (data) => dispatch(setPopup(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sidenav);
